import {outter_post} from 'common/js/axios-helper';
import {UserApi} from "./constant/UrlMapper";

const host = '8882'

const login = (data) => {
    return outter_post(UserApi.Login, data, host);
};

export default {login}



// WEBPACK FOOTER //
// ./src/service/UserService.js